<template>
  <span>
    <span v-if="showNav">
        <a
          data-cy="side-troubleshooting-collapse"
          :aria-expanded="troubleCollaps"
          class="sidebar-menu-item nav-link"
          data-toggle="collapse"
          @click="(troubleCollaps=!troubleCollaps)"
        >
            <template>
                <i class="fa pr-2 fa-tools text-indigo"></i>
                <span class="nav-link-text">Troubleshooting<b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="troubleCollaps" id="collapse-just" :class="troubleCollaps?'show':''" class="collapse">
                <ul class="nav nav-sm flex-column">
                  <slot v-for="(item, index) in links" name="title">
                    <!-- Internal link -->
                    <router-link
                      v-if="item.attr_type === 'internal'"
                      :data-cy="getCypressDataCy(item.link)"
                      :key="index"
                      class="nav-link"
                      :href="item.link"
                      :to="item.link"
                      @click.native="linkClick"
                      :title="item.description"
                      b-v-tooltip.hover
                    >
                      <template>
                          <i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
                          <span class="nav-link-text">{{ item.name }}</span>
                      </template>
                    </router-link>
                    <!-- IFrame link -->
                    <router-link
                      v-else-if="item.attr_type === 'external_iframe'"
                      :data-cy="getCypressDataCy(item.link)"
                      :key="index+'iframe'"
                      class="nav-link"
                      :href="`/iframe/:?src=${item.link}`"
                      :to="`/iframe/:?src=${item.link}`"
                      @click.native="linkClick"
                      :title="item.description"
                      b-v-tooltip.hover
                    >
                      <template>
                          <i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
                          <span class="nav-link-text">{{ item.name }}</span>
                      </template>
                    </router-link>
                    <!-- New window link -->
                    <a
                      v-else
                      :data-cy="getCypressDataCy(item.link)"
                      :key="item.id"
                      class="nav-link"
                      :href="item.link"
                      target="_blank"
                      @click="linkClick"
                      :title="item.description"
                      b-v-tooltip.hover
                    >
                        <template>
                            <i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
                            <span class="nav-link-text">{{ item.name }}</span>
                        </template>
                    </a>
                  </slot>
                </ul>
              </div>
          </collapse-transition>
        </span>
  </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";

export default {
  name: 'side-trouble-dynamic-group',
  components: {
    CollapseTransition
  },
  data() {
    return {
      troubleCollaps: false,
    }
  },
  computed: {
    links() {
      return this.$store.getters["getLinksByGroup"]('Troubleshooting')
    },
    showNav() {
      return this.$store.getters["getLinksByGroup"]('Troubleshooting').length > 0
    },
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    getCypressDataCy(route) {
      let arr = route.split('/');
      let formattedRoute = arr[arr.length - 1];
      if (formattedRoute.includes(':')) {
        formattedRoute = arr[arr.length - 2];
      }
      // console.log(formattedRoute)
      return `side-troubleshooting-${formattedRoute}`;
    },
  }
}
</script>
